import { getCdnUrl } from '@/utils/url'

export const ErrorDetails = [
    {
        errorCode: '404',
        title: 'خطای ۴۰۴',
        text: 'صفحه مورد نظر شما پیدا نشد.',
        image: getCdnUrl('/_toad/images/errors/404.svg'),
    },
    {
        errorCode: '500',
        text: 'مشکلی پیش آمده است. در حال تلاش برای برطرف کردن آن هستیم. لطفا دقایقی دیگر تلاش کنید',
        image: getCdnUrl('/_toad/images/errors/500.svg'),
    },
    {
        errorCode: '503',
        title: 'سرویس در دسترس نمی باشد',
        text: 'سایت موقتا از دسترس خارج شده است.',
        image: getCdnUrl('/_toad/images/errors/503.svg'),
    },
    {
        errorCode: 'default',
        title: '',
        text: 'مشکلی پیش آمده است. در حال تلاش برای برطرف کردن آن هستیم. لطفا دقایقی دیگر تلاش کنید',
        image: getCdnUrl('/_toad/images/errors/default.svg'),
    },
]
